module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mailsetting",
      "role": "tabpanel",
      "aria-labelledby": "recmail-tab"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h4', [_vm._v("通知先メールアドレスの設定")]), _c('p', [_vm._v("お問い合わせがきた際に通知するメールアドレスを設定します。")]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "mail"
    }
  }, [_vm._v("宛先")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.notification_to),
      expression: "form.notification_to"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.form.notification_to.$dirty && _vm.$v.form.notification_to.$invalid
    },
    attrs: {
      "id": "mail",
      "type": "text",
      "placeholder": "受信するメールアドレスを入力"
    },
    domProps: {
      "value": (_vm.form.notification_to)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "notification_to", $event.target.value)
      }, _vm.$v.form.notification_to.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.notification_to.$dirty && _vm.$v.form.notification_to.$invalid),
      expression: "$v.form.notification_to.$dirty && $v.form.notification_to.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.notification_to.required),
      expression: "!$v.form.notification_to.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.notification_to.email),
      expression: "!$v.form.notification_to.email"
    }]
  }, [_vm._v("不正なメールアドレスです")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "cc_mail"
    }
  }, [_vm._v("CC")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.notification_cc),
      expression: "form.notification_cc"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.form.notification_cc.$invalid
    },
    attrs: {
      "id": "cc_mail",
      "type": "text",
      "placeholder": "CCで受信するメールアドレスを入力"
    },
    domProps: {
      "value": (_vm.form.notification_cc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "notification_cc", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.notification_cc.$invalid),
      expression: "$v.form.notification_cc.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.notification_cc.email),
      expression: "!$v.form.notification_cc.email"
    }]
  }, [_vm._v("不正なメールアドレスです")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "bcc_mail"
    }
  }, [_vm._v("BCC")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.notification_bcc),
      expression: "form.notification_bcc"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.form.notification_bcc.$invalid
    },
    attrs: {
      "id": "bcc_mail",
      "type": "text",
      "placeholder": "BCCで受信するメールアドレスを入力"
    },
    domProps: {
      "value": (_vm.form.notification_bcc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "notification_bcc", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.notification_bcc.$invalid),
      expression: "$v.form.notification_bcc.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.notification_bcc.email),
      expression: "!$v.form.notification_bcc.email"
    }]
  }, [_vm._v("不正なメールアドレスです")])])])]), _vm._m(0), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "mail_subject"
    }
  }, [_vm._v("件名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.thanks_title),
      expression: "form.thanks_title"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.form.thanks_title.$dirty && _vm.$v.form.thanks_title.$invalid
    },
    attrs: {
      "id": "mail_subject",
      "type": "text",
      "placeholder": "メールの件名を入力"
    },
    domProps: {
      "value": (_vm.form.thanks_title)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "thanks_title", $event.target.value)
      }, _vm.$v.form.thanks_title.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.thanks_title.$dirty && _vm.$v.form.thanks_title.$invalid),
      expression: "$v.form.thanks_title.$dirty && $v.form.thanks_title.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.thanks_title.required),
      expression: "!$v.form.thanks_title.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.thanks_title.maxLength),
      expression: "!$v.form.thanks_title.maxLength"
    }]
  }, [_vm._v("100文字以下で入力してください")])])])]), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "mail_text"
    }
  }, [_vm._v("本文")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.thanks_header),
      expression: "form.thanks_header"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.form.thanks_header.$dirty && _vm.$v.form.thanks_header.$invalid
    },
    attrs: {
      "id": "mail_text",
      "rows": "10",
      "placeholder": "メールの本文を入力"
    },
    domProps: {
      "value": (_vm.form.thanks_header)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "thanks_header", $event.target.value)
      }, _vm.$v.form.thanks_header.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.thanks_header.$dirty && _vm.$v.form.thanks_header.$invalid),
      expression: "$v.form.thanks_header.$dirty && $v.form.thanks_header.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.thanks_header.required),
      expression: "!$v.form.thanks_header.required"
    }]
  }, [_vm._v("必須項目です")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "inquirycontents_plug"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.include_inquiry_body),
      expression: "form.include_inquiry_body"
    }],
    staticClass: "checkbox01-input",
    attrs: {
      "id": "inquirycontents_plug",
      "type": "checkbox",
      "true-value": 1,
      "false-value": 0
    },
    domProps: {
      "checked": Array.isArray(_vm.form.include_inquiry_body) ? _vm._i(_vm.form.include_inquiry_body, null) > -1 : _vm._q(_vm.form.include_inquiry_body, 1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.include_inquiry_body,
          $$el = $event.target,
          $$c = $$el.checked ? (1) : (0);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "include_inquiry_body", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "include_inquiry_body", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "include_inquiry_body", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "checkbox01-parts"
  }), _c('span', [_vm._v("お問い合わせ内容を差し込む")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "mail_footer"
    }
  }, [_vm._v("フッター")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.thanks_footer),
      expression: "form.thanks_footer"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mail_footer",
      "rows": "5",
      "placeholder": "メールのフッターを入力"
    },
    domProps: {
      "value": (_vm.form.thanks_footer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "thanks_footer", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "mail_signature"
    }
  }, [_vm._v("署名")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.default_signature),
      expression: "form.default_signature"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mail_signature",
      "rows": "5",
      "placeholder": "メールの署名を入力"
    },
    domProps: {
      "value": (_vm.form.default_signature)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "default_signature", $event.target.value)
      }
    }
  })])]), _vm._m(1), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "send_mail"
    }
  }, [_vm._v("メールアドレス")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smtp_mail_address),
      expression: "form.smtp_mail_address"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.form.smtp_mail_address.$dirty && _vm.$v.form.smtp_mail_address.$invalid
    },
    attrs: {
      "id": "send_mail",
      "type": "text",
      "placeholder": "メールアドレスを入力してください"
    },
    domProps: {
      "value": (_vm.form.smtp_mail_address)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "smtp_mail_address", $event.target.value)
      }, _vm.$v.form.smtp_mail_address.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.smtp_mail_address.$dirty && _vm.$v.form.smtp_mail_address.$invalid),
      expression: "$v.form.smtp_mail_address.$dirty && $v.form.smtp_mail_address.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_mail_address.required),
      expression: "!$v.form.smtp_mail_address.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_mail_address.email),
      expression: "!$v.form.smtp_mail_address.email"
    }]
  }, [_vm._v("不正なメールアドレスです")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_mail_address.maxLength),
      expression: "!$v.form.smtp_mail_address.maxLength"
    }]
  }, [_vm._v("100文字以下で入力してください")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "smtpserver"
    }
  }, [_vm._v("送信メールサーバ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smtp_server),
      expression: "form.smtp_server"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.form.smtp_server.$dirty && _vm.$v.form.smtp_server.$invalid
    },
    attrs: {
      "id": "smtpserver",
      "type": "text",
      "placeholder": "サーバ情報を入力してください"
    },
    domProps: {
      "value": (_vm.form.smtp_server)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "smtp_server", $event.target.value)
      }, _vm.$v.form.smtp_server.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.smtp_server.$dirty && _vm.$v.form.smtp_server.$invalid),
      expression: "$v.form.smtp_server.$dirty && $v.form.smtp_server.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_server.required),
      expression: "!$v.form.smtp_server.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_server.ascii),
      expression: "!$v.form.smtp_server.ascii"
    }]
  }, [_vm._v("半角英数記号で入力してください")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_server.maxLength),
      expression: "!$v.form.smtp_server.maxLength"
    }]
  }, [_vm._v("100文字以下で入力してください")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "smtpport"
    }
  }, [_vm._v("SMTPポート")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smtp_port),
      expression: "form.smtp_port"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.form.smtp_port.$dirty && _vm.$v.form.smtp_port.$invalid
    },
    attrs: {
      "id": "smtpport",
      "type": "text",
      "placeholder": "ポート番号を入力してください"
    },
    domProps: {
      "value": (_vm.form.smtp_port)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "smtp_port", $event.target.value)
      }, _vm.$v.form.smtp_port.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.smtp_port.$dirty && _vm.$v.form.smtp_port.$invalid),
      expression: "$v.form.smtp_port.$dirty && $v.form.smtp_port.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_port.required),
      expression: "!$v.form.smtp_port.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_port.numeric),
      expression: "!$v.form.smtp_port.numeric"
    }]
  }, [_vm._v("半角数字で入力してください")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_port.maxLength),
      expression: "!$v.form.smtp_port.maxLength"
    }]
  }, [_vm._v("4文字以下で入力してください")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "smtpsecure"
    }
  }, [_vm._v("SMTPセキュア")]), _c('div', {
    staticClass: "radio02"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smtp_secure),
      expression: "form.smtp_secure"
    }],
    staticClass: "radio02-input",
    attrs: {
      "id": "radio03-01",
      "type": "radio",
      "value": "",
      "name": "radio03"
    },
    domProps: {
      "checked": _vm._q(_vm.form.smtp_secure, "")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.form, "smtp_secure", "")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "radio03-01"
    }
  }, [_vm._v("なし")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smtp_secure),
      expression: "form.smtp_secure"
    }],
    staticClass: "radio02-input",
    attrs: {
      "id": "radio03-02",
      "type": "radio",
      "value": "tls",
      "name": "radio03"
    },
    domProps: {
      "checked": _vm._q(_vm.form.smtp_secure, "tls")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.form, "smtp_secure", "tls")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "radio03-02"
    }
  }, [_vm._v("TLS")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "mailaccount"
    }
  }, [_vm._v("アカウント名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smtp_user),
      expression: "form.smtp_user"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.form.smtp_user.$dirty && _vm.$v.form.smtp_user.$invalid
    },
    attrs: {
      "id": "mailaccount",
      "type": "text",
      "placeholder": "アカウント名を入力してください"
    },
    domProps: {
      "value": (_vm.form.smtp_user)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "smtp_user", $event.target.value)
      }, _vm.$v.form.smtp_user.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.smtp_user.$dirty && _vm.$v.form.smtp_user.$invalid),
      expression: "$v.form.smtp_user.$dirty && $v.form.smtp_user.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_user.required),
      expression: "!$v.form.smtp_user.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_user.ascii),
      expression: "!$v.form.smtp_user.ascii"
    }]
  }, [_vm._v("半角英数記号で入力してください")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_user.maxLength),
      expression: "!$v.form.smtp_user.maxLength"
    }]
  }, [_vm._v("50文字以下で入力してください")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "mailpassword"
    }
  }, [_vm._v("パスワード")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smtp_pass),
      expression: "form.smtp_pass"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.form.smtp_pass.$dirty && _vm.$v.form.smtp_pass.$invalid
    },
    attrs: {
      "id": "mailpassword",
      "type": "text",
      "placeholder": "パスワードを入力してください"
    },
    domProps: {
      "value": (_vm.form.smtp_pass)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "smtp_pass", $event.target.value)
      }, _vm.$v.form.smtp_pass.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.smtp_pass.$dirty && _vm.$v.form.smtp_pass.$invalid),
      expression: "$v.form.smtp_pass.$dirty && $v.form.smtp_pass.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_pass.required),
      expression: "!$v.form.smtp_pass.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_pass.ascii),
      expression: "!$v.form.smtp_pass.ascii"
    }]
  }, [_vm._v("半角英数記号で入力してください")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.smtp_pass.maxLength),
      expression: "!$v.form.smtp_pass.maxLength"
    }]
  }, [_vm._v("50文字以下で入力してください")])])])]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "setting-button"
  }, [_c('a', {
    staticClass: "customsmallbutton btn btn-info",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "button",
      "name": "send-test"
    },
    on: {
      "click": _vm.preSend
    }
  }, [_vm._v("送受信テスト")]), _c('a', {
    staticClass: "customsmallbutton btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保 存")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr'), _c('h4', [_vm._v("自動返信メールの設定")]), _c('p', [_vm._v("お問い合わせがきた際に相手に自動返信するメール内容を設定します。"), _c('br'), _vm._v("（下記のメールサーバ情報で設定したメールアドレスから送信されます）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr'), _c('h4', [_vm._v("メールサーバ設定")]), _c('p', [_vm._v("メールを送信する際に使用するメールアドレス情報を設定します。"), _c('br'), _vm._v("（分からない場合は社内のサーバ責任者の方にお問い合わせください）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08d22966","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/form/Mail.vue
// module id = 589
// module chunks = 1